module.exports = __webpack_public_path__ + "static/media/doulanshanicon.133fa106.webp";